<router-outlet (activate)="onRouterOutletActivate($event)">
  @if (loading) {
    <div class="spinner">
      <div class="bounce1"></div>
      <div class="bounce2"></div>
      <div class="bounce3"></div>
    </div>
  }
</router-outlet>
<app-toaster/>